import React, { useEffect, useState } from 'react';
import * as Sentry from "@sentry/react";
import { useDashboard } from 'routes/dashboard/Dashboard';
import { WithQueryWidgetProps } from './queryWidgetComposition/withQueryWidget';
import { Query } from 'system/query/Query';
import { QueryInfo } from 'system/query/QueryInfo';
import APIRequest from 'system/APIRequest';
import { currentUser } from 'system/InfegyUser';

export interface WidgetSettingsWrapperProps extends WithQueryWidgetProps {
  settingsDialogIsOpen: boolean;
  setSettingsDialogIsOpen: (isOpen: boolean) => void;
}

export interface WidgetSettingsProps extends WidgetSettingsWrapperProps {
  queryInfo?: QueryInfo;
}

export default function WidgetSettingsWrapper(props: WidgetSettingsWrapperProps): JSX.Element {
  const dashboard = useDashboard();
  const user = currentUser();

  const { settingsDialogIsOpen, widgetRegistryInfo } = props;

  const [widgetQueries, setWidgetQueries] = useState<Array<Query> | undefined>(undefined);
  const [queryInfo, setQueryInfo] = useState<QueryInfo | undefined>(undefined);

  const defaultWidgetQueryId = dashboard.data.defaultWidgetQuery;
  const dashboardDataset = dashboard.dataset_id;
  const defaultDashboardQueryId = dashboard.data.defaultDashboardQuery;

  useEffect(() => {
    const queryIds = props.widget?.request_info?.queries?.map(q => q.id).filter(id => id) || [];
    if (queryIds.length === 0) {
      setWidgetQueries([]);
      return;
    }
    APIRequest(`obj/query/${queryIds.join(",")}`).then((response: any) => {
      if (!response.output || !Array.isArray(response.output)) {
        response.output = response?.output ? [response?.output] : [];
      }
      const queries:Array<Query> = response.output.map((query: any) => {
        return new Query(query);
      });
      setWidgetQueries(queries);
    });
  }, [props.widget?.request_info?.queries]);

  useEffect(() => {
    const datasetId = widgetQueries?.[0]?.dataset_id || dashboardDataset || defaultDashboardQueryId;
    if (!datasetId || !user?.permissions?.includes("run_query")) {
      setQueryInfo(undefined);
      return;
    }
    APIRequest(`query-info/${datasetId}`).then((response: any) => {
      setQueryInfo(new QueryInfo(response));
    });
  }, [widgetQueries, dashboardDataset, defaultDashboardQueryId]);

  return (
    <>
    {!!settingsDialogIsOpen && !!widgetRegistryInfo?.settingsComponent && !!dashboard?._modifiable &&
      <Sentry.ErrorBoundary>
        {!!widgetRegistryInfo?.settingsComponent &&
          React.createElement(widgetRegistryInfo?.settingsComponent, {
            ...props,
            queryInfo: queryInfo
          })
        }
      </Sentry.ErrorBoundary>
    }
    </>
  );
}
